/* =====================================================================
   rgh-galeria.js — galeria e zoom no celular (ref. Authentic Feet)

   HISTORICO DO DIAGNOSTICO (medido com navegador real em 12/08/2026)
   ------------------------------------------------------------------
   * A seta "rolava" o modal — mas com o modal aberto o tema trava a rolagem
     da pagina (overflow hidden) e NENHUM elemento da cadeia do modal e'
     rolavel. scrollIntoView/scrollBy nao tinham onde agir. Por isso o zoom
     agora e' um CARROSSEL: uma midia visivel por vez e a seta troca o indice.
     Nao ha' rolagem envolvida — nao ha' como quebrar por rolagem.

   * O botao do WhatsApp e' um custom element <gty-whatsapp-chat-button> com
     shadow DOM: o host nao e' position:fixed (o fixo vive DENTRO do shadow),
     entao filtrar por computed style nunca o encontrava. Agora a limpeza e'
     pela ORDEM DE PINTURA: elementFromPoint no centro de cada botao meu;
     o que estiver na frente e nao for meu, some enquanto o zoom estiver
     aberto — seja qual for o nome, com ou sem shadow DOM.
   ===================================================================== */
(function () {
  'use strict';
  var MOB = function () { return window.matchMedia('(max-width: 749px)').matches; };

  /* ---------------- bolinhas da galeria ---------------- */
  function dots(gal) {
    var lista = gal.querySelector('.product__media-list');
    if (!lista || gal.dataset.rghDots) return;
    var itens = Array.prototype.slice.call(lista.children);
    if (itens.length < 2) return;
    gal.dataset.rghDots = '1';

    var barra = document.createElement('div');
    barra.className = 'rgh-dots';
    itens.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rgh-dots__d' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Ver imagem ' + (i + 1) + ' de ' + itens.length);
      b.addEventListener('click', function () {
        itens[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      barra.appendChild(b);
    });
    lista.parentNode.insertBefore(barra, lista.nextSibling);

    try {
      var obs = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.intersectionRatio < 0.6) return;
          var i = itens.indexOf(e.target);
          if (i < 0) return;
          barra.querySelectorAll('.rgh-dots__d').forEach(function (d, j) {
            d.classList.toggle('is-active', j === i);
          });
        });
      }, { root: lista, threshold: [0.6] });
      itens.forEach(function (el) { obs.observe(el); });
    } catch (e) { /* sem observer as bolinhas ainda navegam */ }
  }

  /* ---------------- zoom em carrossel ---------------- */
  function zoom(modal) {
    if (modal.dataset.rghZoom) return;
    var cont = modal.querySelector('.product-media-modal__content');
    if (!cont) return;
    modal.dataset.rghZoom = '1';

    var idx = 0, escala = 1;
    var escondidos = [], vigia = null, batida = null;

    function midias() { return Array.prototype.slice.call(cont.children); }
    function imgAtual() {
      /* no modal as midias podem SER o proprio <img> (medido: children do
         content sao imgs diretas) — ou um wrapper com o img dentro */
      var el = midias()[idx];
      if (!el) return null;
      if (el.tagName === 'IMG') return el;
      return el.querySelector('img');
    }
    function aplica() {
      var img = imgAtual();
      if (img) {
        img.style.transform = 'scale(' + escala + ')';
        img.style.transition = 'transform .2s';
      }
    }
    function contador() {
      var c = modal.querySelector('.rgh-zctr');
      if (c) c.textContent = (idx + 1) + ' / ' + midias().length;
    }
    function mostra(i) {
      var ms = midias();
      if (!ms.length) return;
      idx = Math.min(ms.length - 1, Math.max(0, i));
      ms.forEach(function (el, j) { el.classList.toggle('rgh-atual', j === idx); });
      escala = 1;
      aplica();
      contador();
    }
    function indiceInicial() {
      /* abre na foto que o cliente tocou, se o tema informar qual foi */
      try {
        var op = modal.openedBy;
        var mid = op && op.getAttribute('data-media-id');
        if (mid) {
          var ms = midias();
          for (var i = 0; i < ms.length; i++) {
            if (ms[i].getAttribute && ms[i].getAttribute('data-media-id') === mid) return i;
            if (ms[i].querySelector && ms[i].querySelector('[data-media-id="' + mid + '"]')) return i;
          }
        }
      } catch (e) { /* cai no 0 */ }
      return 0;
    }

    /* -------- o que estiver PINTANDO sobre os meus botoes sai da frente ----- */
    function ehMeu(el) {
      return modal.contains(el) ||
             (el.className && /(^|\s)rgh-z/.test(String(el.className)));
    }
    function limpaFrente() {
      var meus = modal.querySelectorAll('.rgh-zn, .rgh-zc');
      Array.prototype.forEach.call(meus, function (b) {
        for (var k = 0; k < 4; k++) {          /* pode haver mais de um empilhado */
          var r = b.getBoundingClientRect();
          if (!r.width) return;
          var el = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
          if (!el || el === b || b.contains(el) || ehMeu(el)) return;
          escondidos.push([el, el.style.visibility, el.style.pointerEvents]);
          el.style.visibility = 'hidden';
          el.style.pointerEvents = 'none';
        }
      });
    }
    function devolve() {
      escondidos.forEach(function (p) {
        p[0].style.visibility = p[1] || '';
        p[0].style.pointerEvents = p[2] || '';
      });
      escondidos = [];
    }

    /* ---------- pre-aquecimento das fotos do zoom ----------
       As imagens do modal sao lazy e, no carrossel, as nao-ativas ficam
       display:none — lazy invisivel NUNCA baixa. Sem isto, o download so'
       comecava quando a seta revelava a foto: era o delay de segundos que o
       cliente sentiu. Aqui todas comecam a baixar no primeiro toque na
       galeria (intencao de abrir) e, garantido, na abertura do modal. */
    function preaquece() {
      if (modal.dataset.rghPre) return;
      modal.dataset.rghPre = '1';
      Array.prototype.forEach.call(cont.querySelectorAll('img'), function (img) {
        try {
          img.loading = 'eager';
          img.decoding = 'async';
          if (!img.complete && (img.src || img.srcset)) {
            var pre = new Image();          /* forca o fetch mesmo com display:none */
            if (img.sizes) pre.sizes = img.sizes;
            if (img.srcset) pre.srcset = img.srcset;
            if (img.src) pre.src = img.src;
          }
        } catch (e) { /* segue */ }
      });
    }
    var galeria = document.querySelector('media-gallery');
    if (galeria) {
      galeria.addEventListener('touchstart', preaquece, { passive: true, once: true });
      galeria.addEventListener('pointerdown', preaquece, { passive: true, once: true });
    }

    function bolhaVideo() { return document.querySelector('.rgh-vb'); }
    function abriu() {
      if (!MOB()) return;
      preaquece();
      /* a bolinha de video some (via CSS :has) — aqui so' pausamos o <video>
         para nao gastar bateria tocando invisivel */
      var bv = bolhaVideo();
      if (bv) Array.prototype.forEach.call(bv.querySelectorAll('video'), function (v) {
        try { v.pause(); } catch (e) {}
      });
      cont.classList.add('rgh-carrossel');
      mostra(indiceInicial());
      limpaFrente();
      /* o widget pode ser injetado ou reexibido DEPOIS: vigia enquanto aberto */
      try {
        vigia = new MutationObserver(limpaFrente);
        vigia.observe(document.body, { childList: true, subtree: true });
      } catch (e) { /* a batida abaixo cobre */ }
      batida = setInterval(limpaFrente, 900);
    }
    function fechou() {
      /* pedido do cliente: ao fechar o zoom no X, o video da bolinha volta
         a aparecer ja' TOCANDO DE NOVO desde o inicio */
      var bv = bolhaVideo();
      if (bv && !bv.hasAttribute('hidden')) {
        Array.prototype.forEach.call(bv.querySelectorAll('video'), function (v) {
          try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        });
      }
      cont.classList.remove('rgh-carrossel');
      if (vigia) { vigia.disconnect(); vigia = null; }
      if (batida) { clearInterval(batida); batida = null; }
      devolve();
    }

    function botao(cls, rot, svg, fn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.setAttribute('aria-label', rot);
      b.innerHTML = svg;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); fn();
      });
      modal.appendChild(b);
    }

    var svgPrev = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
    var svgNext = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    var svgMenos = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M5 12h14"/></svg>';
    var svgMais = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';

    botao('rgh-zn rgh-zn--prev', 'Imagem anterior', svgPrev, function () { mostra(idx - 1); });
    botao('rgh-zn rgh-zn--next', 'Proxima imagem', svgNext, function () { mostra(idx + 1); });
    botao('rgh-zc rgh-zc--out', 'Diminuir zoom', svgMenos, function () {
      escala = Math.max(1, escala - 0.5); aplica();
    });
    botao('rgh-zc rgh-zc--in', 'Aumentar zoom', svgMais, function () {
      escala = Math.min(3, escala + 0.5); aplica();
    });

    var ctr = document.createElement('span');
    ctr.className = 'rgh-zctr';
    ctr.setAttribute('aria-hidden', 'true');
    modal.appendChild(ctr);

    try {
      new MutationObserver(function () {
        if (modal.hasAttribute('open')) abriu(); else fechou();
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    } catch (e) { /* sem observer, ainda funciona ao abrir ja' aberto */ }

    if (modal.hasAttribute('open')) abriu();
  }

  function init() {
    if (!MOB()) return;
    document.querySelectorAll('media-gallery').forEach(dots);
    document.querySelectorAll('product-modal, .product-media-modal').forEach(zoom);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', function () { if (MOB()) init(); });
})();
